import clsx from "clsx";
import { FormattedFinanceStatus, FormattedStatus } from "components/job/JobTable/types";
import { getColor, getFinanceStatus } from "components/job/JobTable/PriceStatus/helpers";

export interface PriceStatusPropsHook {
  color: string;
  financed: boolean;
  signed: boolean;
  pending: boolean;
  paid: boolean;
  classNames: {
    wrapperClassName: string;
    poundsClassName: string;
    centsClassName: string;
  };
}

export default function usePriceStatusProps(
  status: FormattedStatus,
  financeStatus: FormattedFinanceStatus
): PriceStatusPropsHook {
  const color = getColor(status, financeStatus);

  const { financed, signed, pending, paid } = getFinanceStatus(financeStatus);

  const strikeThrough = status === "declined";

  const classNames = {
    wrapperClassName: "",
    poundsClassName: clsx("text-14-22-em", strikeThrough && "line-through"),
    centsClassName: clsx("text-14-22-em", strikeThrough && "line-through"),
  };

  return {
    color,
    financed,
    signed,
    pending,
    paid,
    classNames,
  };
}
